import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EChartsOption } from 'echarts';
import { ComponentService } from '../../services/component.service';

@Component({
  selector: 'app-ces-after-market',
  templateUrl: './ces-after-market.component.html',
  styleUrls: ['./ces-after-market.component.scss'],
})
export class CesAfterMarketComponent implements OnInit {
  selectedBtn: string = 'sales';
  selectedDi: string = 'All';
  selectedValues: any = {};
  formDetails: any = {};
  salesByRegion: any = {};
  algorithm: any = {};
  baseUrl: string = '';
  title: string = '';
  salesReal: any = {};
  marginReal: any = {};
  dailySales: any = {};
  top5: any = {};
  dailyrdio: string = 'daily';
  qParam: any = {};
  dataLoaded: boolean = false;
  top5Loaded: boolean = false;
  reset: number = 0;
  currentFilter: string = '';
  radio: any;
  constructor(private service: ComponentService, private router: Router) {
    this.title = 'CES';
    this.baseUrl = '/nrp/CES/';
  }
  option: EChartsOption = {};

  private normalizeMulti(value: any): string[] {
    if (!Array.isArray(value) || value.length === 0) return ['All'];
    return value;
  }

  ngOnInit(): void {
    this.selectedValues['main_region'] = ['All'];
    this.selectedValues['wpt'] = ['All'];
    // this.selectedValues['customer'] = ['All'];
    this.selectedValues['engine_model'] = ['All'];
    this.selectedValues['parts'] = ['All'];
    this.selectedValues['ecc'] = ['All'];
    this.selectedValues['certification'] = ['All'];
    this.selectedValues['country'] = ['All'];
    this.selectedValues['customer'] = ['All'];

    this.qParam = {
      main_region: this.normalizeMulti(this.selectedValues.main_region),
      wpt: this.normalizeMulti(this.selectedValues.wpt),
      // customer: this.selectedValues.customer,
      engine_model: this.normalizeMulti(this.selectedValues.engine_model),
      parts: this.normalizeMulti(this.selectedValues.parts),
      ecc: this.normalizeMulti(this.selectedValues.ecc),
      certification: this.normalizeMulti(this.selectedValues.certification),
      country: this.normalizeMulti(this.selectedValues['country']),
      customer: this.normalizeMulti(this.selectedValues['customer']),
    };
    this.searchFilters();
    this.getSalesByRegion();
    this.getSalesRealization();
    this.getAlgorithms();
  }
  searchFilters() {
    let mainRegion = {
      wpt: this.selectedValues.wpt,
      // customer: this.selectedValues.customer,
      engine_model: this.selectedValues.engine_model,
      parts: this.selectedValues.parts,
      ecc: this.selectedValues.ecc,
      certification: this.selectedValues.certification,
      country: this.selectedValues['country'],
      customer: this.selectedValues['customer'],
    };
    let wpt = {
      main_region: this.selectedValues.main_region,
      // customer: this.selectedValues.customer,
      engine_model: this.selectedValues.engine_model,
      parts: this.selectedValues.parts,
      ecc: this.selectedValues.ecc,
      certification: this.selectedValues.certification,
      country: this.selectedValues['country'],
      customer: this.selectedValues['customer'],
    };

    // let customer = {
    //   main_region: this.selectedValues.main_region,
    //   wpt: this.selectedValues.wpt,
    //   engine_model: this.selectedValues.engine_model,
    //   parts: this.selectedValues.parts,
    //   ecc: this.selectedValues.ecc,
    //   certification: this.selectedValues.certification,
    //   country: this.selectedValues['country'],
    //   customer: this.selectedValues['customer'],
    // };
    let engine_model = {
      main_region: this.selectedValues.main_region,
      wpt: this.selectedValues.wpt,
      // customer: this.selectedValues.customer,
      parts: this.selectedValues.parts,
      ecc: this.selectedValues.ecc,
      certification: this.selectedValues.certification,
      country: this.selectedValues['country'],
      customer: this.selectedValues['customer'],
    };
    let parts = {
      main_region: this.selectedValues.main_region,
      wpt: this.selectedValues.wpt,
      // customer: this.selectedValues.customer,
      engine_model: this.selectedValues.engine_model,
      ecc: this.selectedValues.ecc,
      certification: this.selectedValues.certification,
      country: this.selectedValues['country'],
      customer: this.selectedValues['customer'],
    };
    let ecc = {
      main_region: this.selectedValues.main_region,
      wpt: this.selectedValues.wpt,
      // customer: this.selectedValues.customer,
      engine_model: this.selectedValues.engine_model,
      parts: this.selectedValues.parts,
      certification: this.selectedValues.certification,
      country: this.selectedValues['country'],
      customer: this.selectedValues['customer'],
    };
    let certification = {
      main_region: this.selectedValues.main_region,
      wpt: this.selectedValues.wpt,
      // customer: this.selectedValues.customer,
      engine_model: this.selectedValues.engine_model,
      parts: this.selectedValues.parts,
      ecc: this.selectedValues.ecc,
      country: this.selectedValues['country'],
      customer: this.selectedValues['customer'],
    };
    let country = {
      main_region: this.selectedValues.main_region,
      wpt: this.selectedValues.wpt,
      // customer: this.selectedValues.customer,
      engine_model: this.selectedValues.engine_model,
      parts: this.selectedValues.parts,
      ecc: this.selectedValues.ecc,
      certification: this.selectedValues.certification,
      customer: this.selectedValues['customer'],
    };
    let Customer = {
      main_region: this.selectedValues.main_region,
      wpt: this.selectedValues.wpt,
      // customer: this.selectedValues.customer,
      engine_model: this.selectedValues.engine_model,
      parts: this.selectedValues.parts,
      ecc: this.selectedValues.ecc,
      certification: this.selectedValues.certification,
      country: this.selectedValues['country'],
    };
    if (this.currentFilter != 'main_region') {
      mainRegion['current_dropdown'] = 'main_region';
      this.getDropdowndetails(mainRegion);
    }

    if (this.currentFilter != 'wpt') {
      wpt['current_dropdown'] = 'wpt';
      this.getDropdowndetails(wpt);
    }

    // if (this.currentFilter != 'customer') {
    //   customer['current_dropdown'] = 'customer';
    //   this.getDropdowndetails(customer);
    // }

    if (this.currentFilter != 'engine_model') {
      engine_model['current_dropdown'] = 'engine_model';
      this.getDropdowndetails(engine_model);
    }

    if (this.currentFilter != 'parts') {
      parts['current_dropdown'] = 'parts';
      this.getDropdowndetails(parts);
    }

    if (this.currentFilter != 'ecc') {
      ecc['current_dropdown'] = 'ecc';
      this.getDropdowndetails(ecc);
    }

    if (this.currentFilter != 'certification') {
      certification['current_dropdown'] = 'certification';
      this.getDropdowndetails(certification);
    }

    if (this.currentFilter != 'country') {
      country['current_dropdown'] = 'country';
      this.getDropdowndetails(country);
    }

    if (this.currentFilter != 'customer') {
      Customer['current_dropdown'] = 'customer';
      this.getDropdowndetails(Customer);
    }
  }
  getDropdowndetails(type) {
    this.service
      .getNrpDropDownDetails(type, this.baseUrl + 'dropdown')
      .subscribe((results) => {
        let channel: any[] = [];
        if (type.current_dropdown == 'main_region')
          channel = results.main_region;

        if (type.current_dropdown == 'wpt') channel = results.wpt;
        // if (type.current_dropdown == 'customer') channel = results.customer;
        if (type.current_dropdown == 'certification')
          channel = results.certification;
        if (type.current_dropdown == 'ecc') channel = results.ecc;
        if (type.current_dropdown == 'engine_model')
          channel = results.engine_model;
        if (type.current_dropdown == 'parts') channel = results.parts;
        if (type.current_dropdown == 'country') channel = results.country;
        if (type.current_dropdown == 'customer')
          channel = results.customer;
        const resp = [...new Set(channel)];
        if (type.current_dropdown == 'main_region') {
          this.formDetails['main_region'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'wpt') {
          this.formDetails['wpt'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }

        if (type.current_dropdown == 'customer') {
          this.formDetails['customer'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }

        if (type.current_dropdown == 'country') {
          this.formDetails['country'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }

        if (type.current_dropdown == 'engine_model') {
          this.formDetails['engine_model'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        // if (type.current_dropdown == 'customer') {
        //   this.formDetails['customer'] =
        //     resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        // }
        if (type.current_dropdown == 'ecc') {
          this.formDetails['ecc'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'parts') {
          this.formDetails['parts'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'certification') {
          this.formDetails['certification'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        this.formDetails = { ...this.formDetails };
      });
  }
  searchSalesData(event) {
    this.currentFilter = event.type;
    this.dataLoaded = false;
    this.selectedValues[event.type] = event.value;
    this.qParam[event.type] = event.value;
    this.qParam = {
      main_region: this.normalizeMulti(this.selectedValues.main_region),
      wpt: this.normalizeMulti(this.selectedValues.wpt),
      // customer: this.selectedValues.customer,
      engine_model: this.normalizeMulti(this.selectedValues.engine_model),
      parts: this.normalizeMulti(this.selectedValues.parts),
      ecc: this.normalizeMulti(this.selectedValues.ecc),
      certification: this.normalizeMulti(this.selectedValues.certification),
      country: this.normalizeMulti(this.selectedValues.country),
      customer: this.normalizeMulti(this.selectedValues.customer),
    };
    this.searchFilters();
    this.getSalesByRegion();
    if (this.selectedBtn == 'sales') {
      this.getSalesRealization();
    } else if (this.selectedBtn == 'margin') {
      this.getMarginRealization();
    } else if (this.selectedBtn == 'daily') {
      this.getDailySales();
    }
    if (this.selectedDi !== 'All') {
      this.searchDimension(this.selectedDi);
    }
    this.getAlgorithms();
  }
  getAlgorithms() {
    this.dataLoaded = false;
    this.service
      .getAlgorithm(this.qParam, this.baseUrl + 'algorithm')
      .subscribe((results) => {
        this.algorithm = results;
        this.dataLoaded = true;
      });
  }
  getSalesByRegion() {
    this.salesByRegion = [];
    this.top5Loaded = false;

    this.service
      .getSalesByRegion(this.qParam, this.baseUrl + 'sales')
      .subscribe((results) => {
        this.salesByRegion = results;
        this.top5Loaded = true;
      });
  }
  getSalesRealization() {
    this.salesReal = [];
    this.dataLoaded = false;

    this.service
      .getSalesRealization(this.qParam, this.baseUrl + 'salesrealisation')
      .subscribe((results) => {
        this.salesReal = results;
        this.dataLoaded = true;
      });
  }
  getMarginRealization() {
    this.marginReal = [];
    this.dataLoaded = false;

    this.service
      .getMarginRealization(this.qParam, this.baseUrl + 'marginrealisation')
      .subscribe((results) => {
        this.marginReal = results;
        this.dataLoaded = true;
      });
  }
  getDailySales() {
    this.dailySales = [];
    this.dataLoaded = false;

    this.service
      .getDailySales(this.qParam, this.baseUrl + 'sales/' + this.dailyrdio)
      .subscribe((results) => {
        this.dailySales = results;
        this.dataLoaded = true;
      });
  }
  salesButton() {
    this.selectedBtn = 'sales';
    this.getSalesRealization();
  }
  marginButton() {
    this.selectedBtn = 'margin';
    this.getMarginRealization();
  }
  dailyButton() {
    this.selectedBtn = 'daily';
    this.getDailySales();
  }
  byRegion() {
    this.selectedDi = 'All';
    this.radio = null;
    this.qParam.region = ['All'];
    this.getSalesByRegion();
    if (this.selectedBtn == 'margin') {
      this.getMarginRealization();
    } else if (this.selectedBtn == 'sales') {
      this.getSalesRealization();
    } else if (this.selectedBtn == 'daily') {
      this.getDailySales();
    }
  }
  searchDimension(event) {
    this.qParam = {
      main_region: this.normalizeMulti(this.selectedValues.main_region),
      wpt: this.normalizeMulti(this.selectedValues.wpt),
      // customer: this.selectedValues.customer,
      engine_model: this.normalizeMulti(this.selectedValues.engine_model),
      parts: this.normalizeMulti(this.selectedValues.parts),
      ecc: this.normalizeMulti(this.selectedValues.ecc),
      certification: this.normalizeMulti(this.selectedValues.certification),
      country: this.normalizeMulti(this.selectedValues.country),
      customer: this.normalizeMulti(this.selectedValues.customer),
    };
    this.selectedDi = event;
    this.top5Loaded = false;
    this.top5 = [];
    this.service
      .getTop5(this.qParam, this.baseUrl + 'sales/top5/' + event)
      .subscribe((results) => {
        this.top5 = results;
        this.top5Loaded = true;
      });
  }
  selectedDiamension(event) {
    this.dailyrdio = event;
    this.getDailySales();
  }
  resetFilter() {
    this.reset = this.reset + 1;
    this.selectedValues['main_region'] = ['All'];
    this.selectedValues['wpt'] = ['All'];
    // this.selectedValues['customer'] = ['All'];
    this.selectedValues['engine_model'] = ['All'];
    this.selectedValues['parts'] = ['All'];
    this.selectedValues['ecc'] = ['All'];
    this.selectedValues['certification'] = ['All'];
    this.selectedValues['country'] = ['All'];
    this.selectedValues['customer'] = ['All'];

    this.qParam = {
      main_region: ['All'],
      wpt: ['All'],
      // customer: ['All'],
      engine_model: ['All'],
      parts: ['All'],
      ecc: ['All'],
      certification: ['All'],
      country: ['All'],
      customer: ['All'],
    };
    this.currentFilter = '';
    this.searchFilters();
    this.byRegion();
    this.getAlgorithms();
  }
  onChartClick(event) {
    let qParam = {
      main_region: this.selectedValues.main_region,
      wpt: this.selectedValues.wpt,
      // customer: this.selectedValues.customer,
      engine_model: this.selectedValues.engine_model,
      parts: this.selectedValues.parts,
      ecc: this.selectedValues.ecc,
      certification: this.selectedValues.certification,
      region: this.qParam.region,
      country: this.selectedValues.country,
      customer: this.selectedValues.customer,
      part: this.title,
      flag: 'nrp',
      subModule: 'ctt',
    };
    if (event.name === 'Price\nImpact') {
      qParam['property'] = 'price';
      qParam['title'] = 'Pure Price Impact';
    }
    if (event.name === 'Mix\nImpact') {
      qParam['property'] = 'mix_sales';
      qParam['title'] = 'Price Mix Impact';
    }
    if (event.name === 'Volume\nImpact') {
      qParam['property'] = 'volume_sales';
      qParam['title'] = 'Volume Impact';
    }
    if (event.name === 'Acquisition') {
      qParam['property'] = 'acquisition_sales';
      qParam['title'] = 'Acquisition';
    }
    if (event.name === 'Attrition') {
      qParam['property'] = 'attrition_sales';
      qParam['title'] = 'Attrition';
    }
    if (event.name === 'Brand\nMix') {
      qParam['property'] = 'brand_mix_sales';
      qParam['title'] = 'Brand\nMix';
    }
    if (event.name === 'Forex\nImpact') {
      qParam['property'] = 'forex_sales';
      qParam['title'] = 'Forex Impact';
    }
    if (
      event.value !== 0 &&
      event.name !== '2025' &&
      event.name !== '2026' &&
      event.name !== '2025 YTD\ndemand' &&
      event.name !== '2026 YTD\ndemand'
    ) {
      this.router.navigate(['/detailedView'], {
        queryParams: qParam,
      });
    }
  }
  legendClick(event) {
    if (this.selectedBtn == 'daily') {
      this.qParam.main_region = [event];
      this.qParam.region = null;
      this.getDailySales();
    } else {
      this.qParam.region = [event];
      if (this.selectedBtn == 'sales') {
        this.getSalesRealization();
      }
      if (this.selectedBtn == 'margin') {
        this.getMarginRealization();
      }

      this.getAlgorithms();
    }
  }
}
